<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<form *ngIf="otpCoditon && !nameCondition">
  <div class="input-form">
    <input id="fileInput" type='Email' [(ngModel)]="emailId" name="email" autocomplete="off"
      placeholder="Enter your Email" style="width: 68% !important;" spellcheck="false" (click)="validFunc()">
    <span class="input-group-btn">
      <button class="btn-getotp" (click)="sendOtpByEmail()">Get OTP</button>
    </span>
    <div *ngIf="emailNotValid" class="text-danger" style="width: 100%;">Please Enter
      A Valid Email</div>
  </div>
  <!-- <tc-form-group>
    <tc-input [placeholder]="'Name'" formControlName="name"></tc-input>
  </tc-form-group> -->

  <!-- <tc-form-group>
    <tc-input [placeholder]="'Mobile number'" [type]="'text'" formControlName="mobile"></tc-input>
  </tc-form-group> -->

  <!-- <tc-form-group>
    <tc-input [placeholder]="'Email address'" [type]="'email'" formControlName="email"></tc-input>
  </tc-form-group> -->

  <!-- <tc-form-group>
    <tc-input [placeholder]="'Password'" [type]="'password'" formControlName="pass"></tc-input>
  </tc-form-group> -->
  <div class="col-12" align="center">
    <!-- <button (click)="submitRegistrationForm()" style="background: #47941b !important;"tc-button [view]="'accent'">
      Register
    </button> &nbsp;&nbsp; -->
    <!-- <button 
    tc-button
    [view]="'accent'" style="background: #47941b !important;" (click)=" backClicked()">
      Back  
    </button>  -->
  </div>
  <p style="text-align: center; margin-top: 9px; margin-bottom: -14px;">OR
  <p>
  <div class="col-12 social-log-container" align="center" style="margin-top: 0%;">
    <!-- <button style="width: 100%;" class="btn btn-social-icon btn-google" (click)="signInWithGoogle()">
      <tc-icon [iconClass]="'icofont-google-plus'" class="iconColor"></tc-icon>Sign In with Google
    </button> -->
    <div id="googleOnSingUp" (click)="googleLogin()">

    </div>
    <div>
      <img src="../../../assets/img/facebook-icon.svg" alt="" class="social-login-icon" (click)="signInWithFB()">
  </div>
  </div>
  <!-- <div class="col-12 " align="center" style="padding-top: 2%;">
    <button style="width: 100%;" class="btn btn-social-icon btn-facebook" (click)="signInWithFB()">
      <tc-icon [iconClass]="'icofont-facebook'" class="iconColor"></tc-icon>Sign In with Facebook
    </button>
  </div> -->


</form>
<div class="col-12" *ngIf="!otpCoditon && !nameCondition">
  <h4 class="text-center_second float-left">Verify with OTP</h4><br>
  <div>
    <p class="form_text mail_stored float-left">Sent via Mail to {{emailId}}</p>
  </div><br>
  <div align="center">
    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true}">
    </ng-otp-input>
  </div>
  <div *ngIf="showErrorMessage" class="text-danger" style="text-align: center;">Invalid OTP</div>
  <div class="col-12" class="form_text float-left">
    <!-- <p>
          Typing to auto-fill OTP <strong>00:12</strong>
      </p> -->
    <p>
      Didn't receive an OTP ? <span><a (click)="resendOtp()">RESEND</a></span>
    </p>
  </div>
</div>
<div *ngIf="nameCondition">
  <h4 class="cant-find-name">Sorry, I did not catch your name</h4>
  <div class="input-group" style="padding-bottom: 25px; margin-left: 12px;">
      <input id="fileInput" type='text' [(ngModel)]="userNewName" name="name" autocomplete="off"
          placeholder="Enter your name" style="width: 68% !important;" spellcheck="false" (ngModelChange)="nextBtnConditionFunc()" >
      <span class="input-group-btn">
          <button class="btn-getotp-next" [disabled]="nameNextCondition"
            (click)="nameNextBtn()"  >Next</button>
      </span>
  </div>
</div>